/* eslint-disable import/prefer-default-export */
import store from '@/store'
import { getData } from '@core/utils/http/general'
// import { ref } from '@vue/composition-api'

/**
 * load Catalogos
 * @returns 3 catalogos para subir transaccion
 */
export const requestEC = matricula => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: (!store.state.cuenta.session.token) ? 318 : 38,
    token: store.state.cuenta.session.token,
    mtrl: matricula,
  }
  const webservice = (!store.state.cuenta.session.token) ? 'wsinscripcion' : 'wscompras'

  getData(paramsRequest, webservice)
    .then(response => {
      if (response.status === 500) {
        reject(response.data.message)
      } else resolve(response.data)
    })
    .catch(err => { reject(err) })
})

/**
 * @name ReloadECS Recargar la informacion de estados de cuenta
 * @param {} matricula mtrl del alumno
 * @returns array
 */
export const ReloadECS = matricula => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 41,
    token: store.state.cuenta.session.token,
    mtrl: matricula,
  }

  getData(paramsRequest, 'wscompras')
    .then(response => {
      if (response.status === 500) {
        reject(response.data.message)
      } else resolve(response.data)
    })
    .catch(err => { reject(err) })
})

/**
 * # datosMatriculacion
 * Obtiene los datos necesarios para matricular un registro
 * @param {*} registro id de la tbl pre-registro
 * @returns [array] arreglo de informacion con respecto al registro
 */
export const datosMatriculacion = registro => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 44,
    registro,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wscompras')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
